import { BACKEND_API_BASE_URL } from '../config';

class InstructorsAPI {
  async getAllInstructors(authToken = null, { schoolId } = {}) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const params = new URLSearchParams();
    if (schoolId) params.set('schoolId', schoolId); // Use 'schoolId' to match backend parameter
    const url = `${BACKEND_API_BASE_URL}/api/instructors${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await fetch(url, { headers });
    if (!response.ok) {
      throw new Error('Failed to fetch instructors');
    }
    return response.json();
  }

  async getInstructorById(id, authToken = null) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const url = `${BACKEND_API_BASE_URL}/api/instructors/${id}`;
    const response = await fetch(url, { headers });
    if (!response.ok) {
      throw new Error('Failed to fetch instructor');
    }
    return response.json();
  }

  async createInstructor(instructorData, authToken = null) {
    const headers = {
      'Content-Type': 'application/json',
    };
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${BACKEND_API_BASE_URL}/api/instructors`, {
      method: 'POST',
      headers,
      body: JSON.stringify(instructorData),
    });
    if (!response.ok) {
      throw new Error('Failed to create instructor');
    }
    return response.json();
  }

  async updateInstructor(id, updateData, authToken = null) {
    const headers = {
      'Content-Type': 'application/json',
    };
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${BACKEND_API_BASE_URL}/api/instructors/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(updateData),
    });
    if (!response.ok) {
      throw new Error('Failed to update instructor');
    }
    return response.json();
  }

  async deleteInstructor(id, authToken = null) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${BACKEND_API_BASE_URL}/api/instructors/${id}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) {
      throw new Error('Failed to delete instructor');
    }
    return response.json();
  }
  // Assign a synced instructor (teacher) to a classroom
  async assignInstructorToClassroom(classroomId, instructorId, authToken = null) {
    const headers = { 'Content-Type': 'application/json' };
    if (authToken) headers.Authorization = `Bearer ${authToken}`;

    const response = await fetch(`${BACKEND_API_BASE_URL}/api/classrooms/${classroomId}/assign-instructor`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ synced_teacher_id: instructorId }),
    });
    if (!response.ok) {
      throw new Error('Failed to assign instructor to classroom');
    }
    return response.json();
  }

  // Remove the assigned synced instructor from a classroom
  async removeInstructorFromClassroom(classroomId, authToken = null) {
    const headers = { 'Content-Type': 'application/json' };
    if (authToken) headers.Authorization = `Bearer ${authToken}`;

    const response = await fetch(`${BACKEND_API_BASE_URL}/api/classrooms/${classroomId}/remove-instructor`, {
      method: 'POST',
      headers,
    });
    if (!response.ok) {
      throw new Error('Failed to remove instructor from classroom');
    }
    return response.json();
  }
}

const instructorsAPI = new InstructorsAPI();
export default instructorsAPI;